<template>
  <div id="app">
    <router-view></router-view>
		<!--这里的name不是命名路由时的name，是components对象里的key-->
		<!-- <router-view v-else name="h5Index" /> -->
  </div>
</template>

<script>
import homePage from './view/homePageJsClient.vue'
import StimulateCallback from './view/showcase/SimulateCallback.vue'

export default {
  name: 'App',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    homePage,
    // eslint-disable-next-line vue/no-unused-components
    StimulateCallback,
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>
